import { catchError, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';

import { AlertService } from '@services/alert.service';
import { FilingRestrictedModalService } from '@services/filing-restricted-modal.service';
import { CompanyProfileIncompleteModalService } from '@services/company-profile-incomplete-modal.service';
import { ApiResponseMessageModel } from '@data-layer/models/common';
import { enumRespErrors } from '@data-layer/enums/common';

@Injectable()
export class ErrorResponseInterceptor implements HttpInterceptor {
  constructor(
    private alertService: AlertService,
    private router: Router,
    private filingRestrictedModalService: FilingRestrictedModalService,
    private companyProfileIncompleteModalService: CompanyProfileIncompleteModalService,
  ) {}

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap((response) => {
        if (response instanceof HttpResponse) {
          this.mapResponse(response);
        }
      }),
      catchError((error) => this.catchError(error)),
    );
  }

  private mapResponse<T>(response: HttpResponse<T> | any) {
    if (response.body) {
      this.showMessages(response.body.messages);
    }

    return response;
  }

  private showMessages(messages: ApiResponseMessageModel[]): void {
    if (messages) {
      messages.forEach((message) => {
        if (message.consoleMessage) {
          switch (message.severity) {
            case 'error':
            case 'fatal':
              console.error(message.consoleMessage);
              break;
            case 'warning':
              console.warn(message.consoleMessage);
              break;
            default:
              console.log(message.consoleMessage);
              break;
          }
        }
      });
    }
  }

  private catchError(error: any) {
    if (error instanceof HttpErrorResponse) {
      switch (error.status) {
        case 400:
          // if (error.error && error.error.message) {
          //   this.alertService.error(error.error.message);
          // } else if (error.error && !error.error.error_description) {
          // this.alertService.error('LABELS.SOMETHING_DONT_WORK_MESSAGE');
          // }
          if (error && error.error && error.error.tag === enumRespErrors.CompanyProfileIncomplete) {
            // #13536: ISF / ES duplicate rejected because the IOR profile is incomplete — dedicated modal with a link to the profile
            this.companyProfileIncompleteModalService.open();
          }
          break;
        case 403:
          if (error && error.error && error.error.tag && error.error.tag === enumRespErrors.RecaptchaTokenInvalid) {
            break;
          } else if (error && error.error && error.error.tag === enumRespErrors.BetaFeatureDisabled) {
            // #13383: a feature-flag refusal is handled by the caller (entry point hidden / inline notice), not by /error.
            break;
          } else if (error && error.error && error.error.tag === enumRespErrors.OrganizationFilingRestricted) {
            this.filingRestrictedModalService.open();
            break;
          } else {
            this.router.navigate(['error']);
          }
          break;
        case 503:
        case 504:
          this.router.navigate(['error']);
          break;
      }
    }
    return throwError(error);
  }
}
